export const formatPhoneNumber = (value: string) => {
  return (value.includes('+') ? value : `+${value}`).replace(/-/g, ' ')
}
